"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SurchargeAnnotation["default"];
  }
});
var _SurchargeAnnotation = _interopRequireDefault(require("./SurchargeAnnotation"));